import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignItems: "stretch",
        minWidth: 0
    },
    list: {
        flexDirection: "column",
        alignItems: "stretch"
    }
});
export default stylesheet;
